import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { PersonAndAddressDetails } from '../../../api';
import LabelAndTextBox from '../../molecules/labelandtextbox/LabelAndTextBox';
import './PersonAndAddressDetails.css';

interface PersonAndAddressDetailsProp {
    personAndAddressDetails: PersonAndAddressDetails;
}

const PersonAndAddressDetailsSection: React.FC<PersonAndAddressDetailsProp> = (props) => {
    return (
        <Container className='align-items-center tablecolor'>
            <Row>
                <Col xs={12} md={6} lg={12}>
                    <div className='checkbox-container'>
                        <div className='checkboxes'>
                            <div className='checkbox-1'>
                                <p>Planen gäller:</p>
                                <div className='checkbox-options'>
                                    <div className='checkbox-option'>
                                        <input type="checkbox" name="conduct" defaultChecked={props.personAndAddressDetails?.conduct}
                                            onChange={() => {
                                                if (props.personAndAddressDetails.conduct === false) {
                                                    props.personAndAddressDetails.conduct = true;
                                                }
                                                else if (props.personAndAddressDetails.conduct === true) {
                                                    props.personAndAddressDetails.conduct = false;
                                                }
                                            }} />
                                        <label>Uppförande</label>
                                    </div>
                                    <div className='checkbox-option'>
                                        <input type="checkbox" name="use" defaultChecked={props.personAndAddressDetails?.use}
                                            onChange={() => {
                                                if (props.personAndAddressDetails.use === false) {
                                                    props.personAndAddressDetails.use = true;
                                                }
                                                else if (props.personAndAddressDetails.use === true) {
                                                    props.personAndAddressDetails.use = false;
                                                }
                                            }} />
                                        <label>Användning</label>
                                    </div>
                                    <div className='checkbox-option'>
                                        <input type="checkbox" name="dismantling" defaultChecked={props.personAndAddressDetails?.dismantling}
                                            onChange={() => {
                                                if (props.personAndAddressDetails.dismantling === false) {
                                                    props.personAndAddressDetails.dismantling = true;
                                                }
                                                else if (props.personAndAddressDetails.dismantling === true) {
                                                    props.personAndAddressDetails.dismantling = false;
                                                }
                                            }} />
                                        <label>Nedmontering</label>
                                    </div>
                                    <div className='checkbox-option'>
                                        <input type="checkbox" name="scaff" defaultChecked={props.personAndAddressDetails?.scaff}
                                            onChange={() => {
                                                if (props.personAndAddressDetails.scaff === false) {
                                                    props.personAndAddressDetails.scaff = true;
                                                }
                                                else if (props.personAndAddressDetails.scaff === true) {
                                                    props.personAndAddressDetails.scaff = false;
                                                }
                                            }} />
                                        <label>Ställning</label>
                                    </div>
                                    <div className='checkbox-option'>
                                        <input type="checkbox" name="weatherProtection" defaultChecked={props.personAndAddressDetails?.weatherProtection}
                                            onChange={() => {
                                                if (props.personAndAddressDetails.weatherProtection === false) {
                                                    props.personAndAddressDetails.weatherProtection = true;
                                                }
                                                else if (props.personAndAddressDetails.weatherProtection === true) {
                                                    props.personAndAddressDetails.weatherProtection = false;
                                                }
                                            }} />
                                        <label>Väderskydd</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={6} lg={12}>
                    <div className='header-section-input mb-3'>
                        <h3>1. Person Och Adressuppgifter</h3>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <LabelAndTextBox title='BESTÄLLARE' remark={props.personAndAddressDetails?.customerName}
                        onChange={(value) => props.personAndAddressDetails.customerName = value} />
                </Col>
                <Col xs={12}>
                    <LabelAndTextBox title='KONTAKTPERSON BESTÄLLARE' remark={props.personAndAddressDetails?.customerContactNamePhone}
                        onChange={(value) => props.personAndAddressDetails.customerContactNamePhone = value} />
                </Col>
                <Col xs={12}>
                    <LabelAndTextBox title='UPPFÖRARE AV STÄLLNING' remark={props.personAndAddressDetails?.scaffoldingCompany}
                        onChange={(value) => props.personAndAddressDetails.scaffoldingCompany = value} />
                </Col>
                <Col xs={12}>
                    <LabelAndTextBox title='KONTAKTPERSON' remark={props.personAndAddressDetails?.contactNameAndPhoneNumberSTB}
                        onChange={(value) => props.personAndAddressDetails.contactNameAndPhoneNumberSTB = value} />
                </Col>
                <Col xs={12}>
                    <LabelAndTextBox title='SAMORDNINGSANSVARIG FÖR ARBETSPLATSEN' remark={props.personAndAddressDetails?.coordinatorForWorkplace}
                        onChange={(value) => props.personAndAddressDetails.coordinatorForWorkplace = value} />
                </Col>
            </Row>
            <hr />
        </Container>
    );
};

export default PersonAndAddressDetailsSection;